// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JiXS","rootNoMargin":"styles_rootNoMargin__3qf35"};